import React from 'react'

const meetingCard = ({ title, children }) => (
  <div className="card border-0 shadow bg-dark align-items-center h-100 m-md-5">
    <div className="card-body py-4 text-center text-white d-flex flex-column align-items-center justify-content-center">
      <h4 className="card-title">
        { title }
      </h4>
      { children }
    </div>
    <div className="d-none">
    <div className="bg-circle bg-circle-1"></div>
    <div className="bg-circle bg-circle-2"></div>
    <div className="bg-circle bg-circle-3"></div>
    <div className="bg-circle bg-circle-4"></div>
    </div>
  </div>
)
export default meetingCard
